export interface RouteHitPayload {
  readonly path: string;
  readonly referrerHost: string | null;
  readonly utmSource: string | null;
  readonly utmMedium: string | null;
  readonly utmCampaign: string | null;
  readonly gclid: string | null;
}

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"] as const;
const ENDPOINT = "/api/event";

function referrerHost(): string | null {
  if (typeof document === "undefined") return null;
  const ref = document.referrer;
  if (!ref) return null;
  try {
    const url = new URL(ref);
    if (typeof window !== "undefined" && url.hostname === window.location.hostname) {
      return null;
    }
    return url.hostname;
  } catch {
    return null;
  }
}

export function buildHit(path: string, search: string): RouteHitPayload {
  const params = new URLSearchParams(search);
  return {
    path,
    referrerHost: referrerHost(),
    utmSource: params.get(UTM_KEYS[0]),
    utmMedium: params.get(UTM_KEYS[1]),
    utmCampaign: params.get(UTM_KEYS[2]),
    gclid: params.get("gclid"),
  };
}

export function sendHit(hit: RouteHitPayload): void {
  if (typeof window === "undefined") return;
  const body = JSON.stringify(hit);

  if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
    try {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(ENDPOINT, blob)) return;
    } catch {
      // Fall through to fetch fallback.
    }
  }

  void fetch(ENDPOINT, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {
    // Best-effort. Never block or surface to the user.
  });
}
